export const LOG_LEVELS = [
  {
    name: 'Info',
    color: 'tertiary-color',
  },
  {
    name: 'Warning',
    color: 'accent-color',
  },
  {
    name: 'Error',
    color: 'error-color',
  },
];

export const LAUNCHDARKLY_INFO = {
  stagingId: '644feab313a8fb12f3ca107b',
  prodId: '644feab313a8fb12f3ca107c',
  initialContext: {
    kind: 'user',
    key: 'anon',
    anonymous: true,
  },
};

export const PROVIDERS = { 
  square: 'square', 
  aeropay: 'aeropay', 
  manifest: 'manifest',
  airtable: 'airtable',
  wheniwork: 'wheniwork',
  payroll: 'payroll',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DEFAULT_WEBHOOKS: { [key: string]: any } = {
  square: {
    // Square webhooks are disabled for the user, we can change the description of them even though,
    // the description is not accurate with the webhook action. Thus, the user will know exactly what the integration does.
    taskStarted: {
      disabled: true,
      label: 'The Square carrier field will be updated when a task is assigned',
      required: true,
    },
    taskUpdated: {
      disabled: true,
      label: 'The Square order state will be updated when a task is unassigned',
      required: true,
    },
    taskDeleted: {
      disabled: true,
      label: 'The Square order state will be updated when a task is started',
      required: true,
    },
    taskFailed: {
      disabled: true,
      label:
        'The Square order and order fulfillment state will be updated when a task is completed, deleted, and failed',
      required: true,
    },
  },
};
